import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  min-height: 100%;
  width: 100%;
  padding: ${theme.spacing(3)};
`

export const header = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
  position: relative;
  display: block;

  font-weight: 700;
`

export const userLogin = (theme: Theme) => css`
  display: block;

  margin-top: ${theme.spacing(5)};

  font-size: 18px;
  font-weight: 700;
  color: ${theme.colors.typographyTwo};
`

export const emailLink = (theme: Theme) => css`
  color: ${theme.colors.blue};
  text-decoration: none;
`

export const tabs = (theme: Theme) => css`
  flex-wrap: wrap;
  margin: ${theme.spacing(3, 0)};
`
